
















import Vue from 'vue';
import { Model, Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import NamedColors from '@frontend/types/base/NamedColors';

@Component({
	components: {}
})
export default class ToggleCircle extends Vue {
	@Model('input')
	protected readonly checked!: string[] | boolean;

	@Prop(String)
	protected readonly label!: string;

	@Prop(String)
	protected readonly value!: string | null;

	@Prop({ type: String, default: 'white' })
	protected readonly color?: NamedColors;

	protected onChange(event: Event): void {
		// Simple checkbox handling
		if (!Array.isArray(this.checked)) {
			this.$emit('input', (event.target as HTMLInputElement).checked);
			return;
		}

		if (!this.value) {
			return;
		}

		// Array checkbox handling
		const checked: string[] = ([] as string[]).concat(this.checked as string[]);

		if (checked.includes(this.value)) {
			checked.splice(checked.indexOf(this.value), 1);
		} else {
			checked.push(this.value);
		}

		this.$emit('input', checked);
	}
}
